import * as React from "react"

import { cn } from "@/lib/utils"

// Today in YYYY-MM-DD (local) — cached at module load. Cheap; auto-refreshes on
// full page load which is fine for an ERP session.
const TODAY_ISO = new Date().toISOString().slice(0, 10);

const Input = React.forwardRef(({ className, type, min, ...props }, ref) => {
  // Global rule: forward-only date fields. If a caller wants to allow past
  // dates (filter bars, historical lookups) they pass an explicit `min`
  // (usually `min="1900-01-01"`). Everything else — quotations, invoices,
  // receipts, deadlines — defaults to today so users can't back-date entries.
  const effectiveMin = type === "date" ? (min ?? TODAY_ISO) : min;
  return (
    <input
      type={type}
      min={effectiveMin}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
